import React from 'react'
import PropTypes from 'prop-types'
import { Form, FormGroup } from 'react-bootstrap'
import DatePicker from 'react-datepicker'
import Input from './Input'
import HintField from '../HintField'
import 'react-datepicker/dist/react-datepicker.css';
import './style.css'


export default class TimeField extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    labelStyle: PropTypes.object,
    inputStyle: PropTypes.object,
    value: PropTypes.instanceOf(Date),
    onChange: PropTypes.func,
    style: PropTypes.object,
    hint: PropTypes.string,
    errors: PropTypes.object,
    timeFormat: PropTypes.string,
    required: PropTypes.bool,
    labelsAsPlaceholders: PropTypes.bool,
    className: PropTypes.string
  }

  static defaultProps = {
    labelsAsPlaceholders: false,
    labelStyle: {},
    inputStyle: {},
    className: ''
  }

  get errorMessage() {
    const { errors, name } = this.props

    if(errors && errors[name]) {
      return errors[name][0]
    }
    return null
  }

  get helpMessage() {
    const { hint } = this.props
    return this.errorMessage || hint || null
  }

  render() {
    const { name, className, label, value, onChange, hint, style, errors, timeFormat, required, labelsAsPlaceholders, labelStyle, inputStyle } = this.props
    const { helpMessage } = this

    return (
      <FormGroup
        style={{...styles.wrapper, ...style}}
        className={`checkcherry__widget__timepicker ${className} ${name}`}>
        { (!labelsAsPlaceholders) &&
          <div>
          <Form.Label style={{...styles.label, ...labelStyle}}>
            { label }
            { required && <span style={styles.required}>*</span> }
          </Form.Label>
          </div>
        }
        <DatePicker
          name={name}
          customInput={<Input style={{...styles.input, ...inputStyle}} />}
          onChange={onChange}
          selected={value}
          showTimeSelect
          showTimeSelectOnly
          timeIntervals={15}
          dateFormat={timeFormat}
          timeFormat={timeFormat}
          timeCaption="Time"
          style={{width: "100%"}}
          placeholderText={labelsAsPlaceholders ? label : null}
          isInvalid={!!this.errorMessage}
        />
        <HintField
          hint={hint}
          errorMessage={this.errorMessage}
        />
      </FormGroup>
    )
  }
}

const styles = {
  label: {
    fontSize: 18,
  },
  input: {
    fontSize: 18
  },
  required: {
    color: "#cc0000",
    fontWeight: "normal",
    paddingLeft: 2
  }
}
